import { render, staticRenderFns } from "./Produtosparados.vue?vue&type=template&id=4a8ae190&"
import script from "./Produtosparados.vue?vue&type=script&lang=js&"
export * from "./Produtosparados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports